import {
  SkeletonText,
  Box,
  SkeletonAvatar,
  SkeletonTag,
} from '@dev-spendesk/grapes';
import {
  useHistory,
  useParams,
  useLocation,
  matchPath,
} from 'react-router-dom';

import { SidePanelLoader } from 'src/core/common/components/SidePanel';
import { useTranslation } from 'src/core/common/hooks/useTranslation';
import { routes, routeFor } from 'src/core/constants/routes';

export const AccountPayableSuppliersPanelLoader = ({
  selectedTab,
}: {
  selectedTab: 'current' | 'archived';
}) => {
  const { t } = useTranslation('global');
  const history = useHistory();
  const location = useLocation();
  const { company } = useParams();
  const matchSupplierDetails = matchPath<{ supplierId: string }>(
    location.pathname,
    {
      path: routes.COMPANY_ACCOUNTS_PAYABLE_SUPPLIER_DETAIL.path,
      exact: true,
      strict: false,
    },
  );
  const matchAccountPayableSuppliersDetail = matchPath<{
    accountPayableId: string;
  }>(location.pathname, {
    path: routes.COMPANY_ACCOUNTS_PAYABLE_SUPPLIERS_DETAIL.path,
    exact: true,
    strict: false,
  });

  const handleSuppliersPanelClose = () => {
    if (matchSupplierDetails) {
      history.push({
        pathname: routeFor(routes.COMPANY_ACCOUNTS_PAYABLE.path, {
          company,
          list: selectedTab,
        }),
        search: location.search,
      });
    }
    if (matchAccountPayableSuppliersDetail) {
      history.push({
        pathname: routeFor(routes.COMPANY_ACCOUNTS_PAYABLE_SUPPLIERS.path, {
          accountPayableId:
            matchAccountPayableSuppliersDetail?.params.accountPayableId ?? '',
          company,
          list: selectedTab,
        }),
        search: location.search,
      });
    }
  };

  return (
    <SidePanelLoader
      onClose={handleSuppliersPanelClose}
      title={t('bookkeep.accountsPayable.panel.headerTitle')}
      header={
        <div className="-mb-24 flex flex-col gap-8">
          <Box
            variant="secondary"
            className="flex min-h-[80px] items-center py-16"
          >
            <div className="flex w-full items-center gap-8">
              <SkeletonAvatar size="m" className="shrink-0" variant="square" />
              <SkeletonText size="xxl" width="200px" className="block" />
              <SkeletonTag width="100px" className="ml-auto block" />
            </div>
          </Box>
        </div>
      }
    >
      <div>
        <SkeletonText size="xl" width="33%" className="block h-24" />
        <SkeletonText size="xl" width="50%" className="my-16 block h-24" />
      </div>
    </SidePanelLoader>
  );
};
